"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpProductCartTile = void 0;
const gs = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const Helper_1 = require("../Helper");
const ClassesTags_1 = require("../ClassesTags");
const FilesTags_1 = require("../FilesTags");
const FavoriteController_1 = require("../../appProfiMall/controllers/FavoriteController");
const CartController_1 = require("../../appProfiMall/controllers/CartController");
class CmpProductCartTile extends tmpls_1.CmpProductCartTileBase {
    constructor() {
        super();
    }
    fill(product, qty, statusOk) {
        this._product = product;
        const ctrl = this.ctrls;
        ctrl.aName.text = product.name;
        ctrl.aName.el.setAttribute('href', "/product/" + product.id);
        this._qty = qty;
        this._refreshQty(this._qty);
        [ctrl.statusOk, ctrl.statusNone, ctrl.statusDelivery].forEach(s => s.hide());
        if (statusOk)
            ctrl.statusOk.show();
        else {
            ctrl.statusNone.show();
            ctrl.btnQtyUp.disable();
            ctrl.btnQtyDown.disable();
        }
        //TODO временное(удалить потом) 
        ctrl.lRemainderCount.text = product.remainder + "";
        if (product.rate < 0)
            ctrl.blockRate.hide();
        else
            ctrl.lRate.text = product.rate + "";
        // //TODO сравнение
        // ctrl.btnCompare.hide();
        // ctrl.btnAddToCart.onclick = ()=> App.Inst.cart.addProduct(product.id, 1);
        const favoriteCtrl = App_1.App.Inst.getInst(FavoriteController_1.FavoriteController);
        const cartCtrl = App_1.App.Inst.getInst(CartController_1.CartController);
        let isFavorite = favoriteCtrl.isFavorite(product.id);
        this._setFavorite(isFavorite);
        ctrl.btnFavorite.onclick = (e) => {
            gs.events.stop(e);
            if (isFavorite)
                favoriteCtrl.removeFavorite(product.id);
            else
                favoriteCtrl.addFavorite(product.id);
            isFavorite = !isFavorite;
            this._setFavorite(isFavorite);
        };
        // //TODO бонусы
        // ctrl.blockBonus.hide();
        const mainFoto = product.fotos.find(f => f.tag == FilesTags_1.FilesTags.ImgMain);
        if (mainFoto) {
            ctrl.img1.src = "/fs/products/pv256/" + mainFoto.id;
        }
        ctrl.btnDelete.onclick = () => this.removeFromCart();
        ctrl.btnQtyUp.onclick = () => {
            if (this._qty >= this._product.remainder)
                return;
            cartCtrl.addProduct(product.id, 1, product.weightKg);
            this._qty++;
            this._refreshQty(this._qty);
        };
        ctrl.btnQtyDown.onclick = () => {
            if (this._qty == 1)
                return;
            cartCtrl.removeProduct(product.id, 1);
            this._qty--;
            this._refreshQty(this._qty);
        };
    }
    removeFromCart() {
        App_1.App.Inst.getInst(CartController_1.CartController).removeProduct(this._product.id, this._qty);
        this.cut();
    }
    _refreshQty(qty) {
        const ctrl = this.ctrls;
        this._qty = qty;
        this.ctrls.lQty.text = this._qty + "";
        ctrl.lPrice.text = Helper_1.Helper.toPriceString(this._product.price);
        ctrl.lCost.text = Helper_1.Helper.toPriceString(this._product.price * this._qty);
        ctrl.lCostOld.hide();
        ctrl.lDiscount.hide();
    }
    _setFavorite(value) {
        const btn = this.ctrls.btnFavorite;
        if (value)
            btn.addClass(ClassesTags_1.ClassesTags.Active);
        else
            btn.removeClass(ClassesTags_1.ClassesTags.Active);
    }
}
exports.CmpProductCartTile = CmpProductCartTile;
//# sourceMappingURL=CmpProductCartTile.js.map